module.exports = __webpack_public_path__ + "static/media/index-price.b17e2648.jpg";